module.exports = __webpack_public_path__ + "static/media/dxiconsmaterial.ade00e8f.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/styles/icons/dxiconsmaterial.ttf
// module id = 7864
// module chunks = 0